module.exports = __webpack_public_path__ + "img/shopping-cart.472a903b.svg";